module.exports = __webpack_public_path__ + "img/user.0c5b938a.png";